import { Injectable } from '@angular/core';
import { PackingBoxViewAuthService } from '../../../views/packing-box/services/auth.service';

/**
 * Packing box auth for the Tanks department. Only leaders/admins may create
 * labels (operators are excluded), per the department's access policy.
 */
@Injectable({
  providedIn: 'root',
})
export class TanksPackingBoxAuthService extends PackingBoxViewAuthService {
  override createLabel(): boolean {
    return this.lookForRolesNeeded([
      'Admin',
      'Chief',
      'Tanks',
      'TankAdmin',
      'TankChief',
      'TankLeader',
    ]);
  }
}
